export default __webpack_public_path__ + "static/media/forestly-noexpl-03b_DE.5e392273.png";